import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-ellipsis",
  templateUrl: "./med-icon-ellipsis.component.html",
})
export class MedIconEllipsisComponent extends SvgMixinComponent {}
